import { useAtomValue } from "jotai";

import { appFlowAtom } from "atoms/appFlow";
import { latestReachedCheckpointFlowPageAtom } from "atoms/latestReachedCheckpointFlowPageAtom";
import { Checkpoint } from "types/Checkpoint";

export const useCheckpoint = (targetCheckpoint: Checkpoint | undefined): boolean => {
  const latestReachedCheckpoint = useAtomValue(latestReachedCheckpointFlowPageAtom);
  const appFlow = useAtomValue(appFlowAtom);

  let targetReached = false;

  if (targetCheckpoint) {
    const allCheckpointFlowpages = appFlow.filter((flowPage) => Boolean(flowPage.checkpoint));

    const latestReachedCheckpointIndex = allCheckpointFlowpages.findIndex(
      (checkpointFlowPage) => checkpointFlowPage.checkpoint === latestReachedCheckpoint?.checkpoint
    );

    const targetCheckpointIndex = allCheckpointFlowpages.findIndex(
      (checkpointFlowPage) => checkpointFlowPage.checkpoint === targetCheckpoint
    );

    targetReached = targetCheckpointIndex !== -1 && targetCheckpointIndex <= latestReachedCheckpointIndex;
  }

  return targetReached;
};
